import React from "react";
import { 
    useEffect, 
    useState,
} from "react";
import { 
    Outlet,
    useNavigate, 
    // useSearchParams,
} from "react-router-dom";

import { useAuth } from "react-oidc-context";
import { CircularProgress, Fade } from "@mui/material";
import SessionExpiredModal from "../../utils/SessionExpiredModal";
import GayatriSetup from "./SetUp/GayatriSetup";
import QuickAccessBar from "../../utils/QuickAccessBar";



export default function SetUpRequired(props) {

    const [isLoading, setIsLoading] = useState(false)




  
    


    return (
        <React.Fragment>
              
                    
            <Fade in={isLoading}>
              
              <div style={{ height: '100vh', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backdropFilter: 'blur(30px)', backgroundColor: 'rgb(255, 255, 255, 0.06)', position: 'absolute', zIndex: '1' }}>
                <CircularProgress color="inherit" />
              </div>
            </Fade>

           
            <div style={{display: 'flex', flexDirection: 'column'}}>
                
            

              <div style={{flex: 1, width: '100vw'}}>
                {props.children}

                
              </div>
            </div>
            
        </React.Fragment>
    );
}